export default "__VITE_ASSET__CnjO$JPw__"